export const conversationType =[
    "All Messages","Text","Chat","Direct Post"
]